import { render, staticRenderFns } from "./AppMenu.vue?vue&type=template&id=b0ff8eaa"
import script from "./AppMenu.vue?vue&type=script&lang=js"
export * from "./AppMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports